import React, { PropTypes, DOM } from "react";
import { Field } from "redux-form";
import { requiredValidate, lengthValidate } from "../../helpers";

// Moment Dependency
import moment from "moment";
// import momentLocalizer from 'react-widgets/lib/localizers/moment'
// import configure from 'react-widgets/lib/configure'

// Date Time Picker (react-widgets)
// import 'react-widgets/styles.css'
import { formatPhone, phoneNormalize } from "utils/helpers";

// Rubix Components
import { FormGroup, Label, Button, Row, Col, Alert } from "reactstrap";
// import Panel from 'react-bootstrap/lib/Panel'

import FormNavigation from "../navigation.component";

// const textarea = DOM.textarea
// configure.setDateLocalizer(momentLocalizer(moment))

const lengthValidateFn = lengthValidate(1);

const renderTextArea = ({ input, meta: { touched, error, warning } }) => (
  <div>
    <textarea className="form-control" {...input} />
    {touched &&
      ((error && <span>{error}</span>) || (warning && <span>{warning}</span>))}
  </div>
);

/*
 *
 * Pickup Form render
 *
 * */
const PickupForm = (props) => {
  // Redux form props
  const { handleSubmit, error } = props;

  // Props passed for creating a pickup
  const { hasFurniture, user, publicFormValues } = props;
  // const { phoneNumber } = user;

  const pickupBlock = props.pickupBlock;
  const pickupLocation =
    props.publicFormValues.location || props.pickupLocation;
  // let displayPhone = user.phoneNumber
  //   ? user.phoneNumber
  //   : user.phoneNumbers
  //   ? user.phoneNumbers[0].number
  //   : null;

  return pickupLocation ? (
    <form onSubmit={handleSubmit}>
      <div className={"p-4 box"}>
        <FormGroup>
          <strong>
            {pickupLocation.fullAddress}
            <br />
            {moment.utc(pickupBlock.date).format("dddd, MMMM Do, YYYY")}
          </strong>
        </FormGroup>

        <FormGroup>
          <Label>Notes</Label>
          <Field name="notes" component={renderTextArea} />
        </FormGroup>

        {pickupBlock.zone.pickupType.requireItemsGroundFloor && (
          <FormGroup>
            <Label>Large Item(s) Description*</Label>
            <Field
              name="largeItemsNotes"
              component={renderTextArea}
              validate={[requiredValidate, lengthValidateFn]}
            />
          </FormGroup>
        )}

        {props.publicFormValues.images.length > 0 ? (
          <FormGroup>
            <Label>Photos</Label>
            <Row>
              {props.publicFormValues.images.map((image) => (
                <Col
                  md={3}
                  xs={12}
                  style={{ display: "flex", alignItems: "center" }}
                  className="my-2"
                >
                  <img width={"100%"} src={image} />
                </Col>
              ))}
            </Row>
          </FormGroup>
        ) : null}
      </div>
      {error && <div className="error">{error}</div>}
      <FormNavigation nextLabel="Finish" {...props} />
    </form>
  ) : null;
};

export default PickupForm;
